<template>
  <Layout>
    <!-- WEB HEADER -->
    <div class="row mb-2" v-show="!isMobile">
      <div class="col-sm-3">
        <div class="search-box me-2 mb-2 d-inline-block">
          <div class="position-relative">
            <input
              type="text"
              class="form-control"
              placeholder="Search Incident"
            />
            <i class="bx bx-search-alt search-icon"></i>
          </div>
        </div>
      </div>

      <div class="col-9">
        <div class="text-sm-end">
          <button
            type="button"
            @click="showRaiseNewIncident"
            class="btn btn-info btn-rounded mb-2 me-2"
          >
            <i class="mdi mdi-plus me-1"></i> Raise New Incident
          </button>
        </div>
      </div>
    </div>

    <!-- MOBILE HEADER -->
    <div class="row mb-2" v-show="isMobile">
      <div class="col-12">
        <div class="text-sm-end">
          <button
            type="button"
            @click="showRaiseNewIncident"
            class="btn btn-primary mt-2 mb-2 me-2"
            style="width: 100%"
          >
            <i class="mdi mdi-plus me-1"></i> Raise New Incident
          </button>
        </div>
      </div>
    </div>

    <b-tabs pills justified content-class="p-3 text-muted" class="webViewTable">
      <b-tab active>
        <template v-slot:title>
          <span class="d-inline-block d-sm-none"> Open </span>
          <span class="d-none d-sm-inline-block">Open</span>
        </template>

        <div class="table-responsive mb-0 webViewTable">
          <b-table
            class="datatables"
            :items="openIncidents"
            :fields="fields"
            responsive="sm"
            :per-page="perPage"
            :current-page="currentPage"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :filter="filter"
            :filter-included-fields="filterOn"
            @filtered="onFiltered"
          >
            <template #cell(vehicle_no)="row">
              {{ !row.item.vehicle_no ? "NA" : row.item.vehicle_no }}
            </template>

            <template #cell(sub_category_name)="row">
              {{
                !row.item.sub_category_name ? "NA" : row.item.sub_category_name
              }}
            </template>

            <template #cell(actions)="row">
              <b-button
                size="sm"
                variant="primary"
                class="m-1"
                @click="showIncidentDetails(row.item)"
              >
                View
              </b-button>
              <b-button
                size="sm"
                variant="danger"
                class="m-1"
                @click="showReportModal(row.item)"
              >
                Report
              </b-button>
            </template>

            <template #cell(status)="row">
              <span :class="`badge ${getStatusClass(row.item.status)}`">{{
                row.item.status
              }}</span>
            </template>
          </b-table>
        </div>
      </b-tab>

      <b-tab>
        <template v-slot:title>
          <span class="d-inline-block d-sm-none"> Resolved </span>
          <span class="d-none d-sm-inline-block">Resolved</span>
        </template>

        <div class="table-responsive mb-0 webViewTable">
          <b-table
            class="datatables"
            :items="resolvedIncidents"
            :fields="fields"
            responsive="sm"
            :per-page="perPage"
            :current-page="currentPage"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :filter="filter"
            :filter-included-fields="filterOn"
            @filtered="onFiltered"
          >
            <template #cell(vehicle_no)="row">
              {{ !row.item.vehicle_no ? "NA" : row.item.vehicle_no }}
            </template>

            <template #cell(sub_category_name)="row">
              {{
                !row.item.sub_category_name ? "NA" : row.item.sub_category_name
              }}
            </template>

            <template #cell(actions)="row">
              <b-button
                size="sm"
                variant="primary"
                class="m-1"
                @click="showIncidentDetails(row.item)"
              >
                View
              </b-button>
              <b-button
                size="sm"
                variant="danger"
                class="m-1"
                @click="showReportModal(row.item)"
              >
                Report
              </b-button>
            </template>

            <template #cell(status)="row">
              <span :class="`badge ${getStatusClass(row.item.status)}`">{{
                row.item.status
              }}</span>
            </template>
          </b-table>
        </div>
      </b-tab>
    </b-tabs>

    <!-- Mobile View  -->
    <b-tabs pills justified content-class="p-3 text-muted" class="mobileView">
      <!-- Pending tab details -->
      <b-tab active>
        <template v-slot:title>
          <span class="d-inline-block d-sm-none"> Pending </span>
          <span class="d-none d-sm-inline-block">Pending</span>
        </template>
        <div v-for="accident in this.allIncidents" :key="accident.id">
          <div class="card" v-if="accident.status === 'Open'">
            <div
              class="card-header text-center"
              style="text-transform: uppercase"
            >
              {{ accident.category_name }}
            </div>
            <div class="card-body">
              <div class="row">
                <p class="col-7">
                  {{ accident.category_name }} ID.: {{ accident.id }}
                </p>
              </div>
              <p>Chainage No.: {{ accident.ch_no }}</p>
              <p>Reportd by.: {{ accident.reported_by_name }}</p>
              <p>
                Date | Time:
                {{ accident.reported_datetime }}
              </p>
              <div class="row">
                <!-- <div class="col-6">
                  <b-button
                    size="sm"
                    variant="primary"
                    class="m-1 col-12"
                    @click="viewReportIncidentPage(accident)"
                  >
                    View
                  </b-button>
                </div> -->
                <div class="">
                  <b-button
                    block
                    size="sm"
                    variant="danger"
                    class="m-1 col-12"
                    @click="showReportIncidentPage(accident)"
                  >
                    Report
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-tab>
      <!-- Resolved tab details -->
      <b-tab>
        <template v-slot:title>
          <span class="d-inline-block d-sm-none"> Resolved </span>
          <span class="d-none d-sm-inline-block">Resolved</span>
        </template>
        <div v-for="accident in this.allIncidents" :key="accident.id">
          <div class="card" v-if="accident.status === 'Resolved'">
            <div
              class="card-header text-center"
              style="text-transform: uppercase"
            >
              {{ accident.category_name }}
            </div>
            <div class="card-body">
              <div class="row">
                <p class="col-7">
                  {{ accident.category_name }} ID.: {{ accident.id }}
                </p>
              </div>
              <p>Chainage No.: {{ accident.ch_no }}</p>
              <p>Reportd by.: {{ accident.reported_by_name }}</p>
              <p>
                Date | Time:
                {{ accident.reported_datetime }}
              </p>
              <div class="row">
                <div class="">
                  <b-button
                    block
                    size="sm"
                    variant="primary"
                    class="m-1 col-12"
                    @click="viewReportIncidentPage(accident)"
                  >
                    View
                  </b-button>
                </div>
                <!-- <div class="col-6">
                  <b-button
                    size="sm"
                    variant="danger"
                    class="m-1 col-12"
                    @click="showReportModal(accident)"
                    disabled
                  >
                    Report
                  </b-button>
                </div> -->
              </div>
            </div>
          </div>
        </div>
      </b-tab>
    </b-tabs>
    <div class="row">
      <div class="col-12">
        <div
          class="
            dataTables_paginate
            paging_simple_numbers
            d-flex
            align-items-center
            justify-content-center
          "
        >
          <ul class="pagination pagination-rounded mb-0">
            <!-- pagination -->
            <b-pagination
              class="m-3"
              v-model="currentPage"
              :total-rows="rows"
              :per-page="perPage"
            ></b-pagination>
          </ul>
        </div>
      </div>
    </div>

    <!-- report incident modal -->
    <b-modal
      id="report-incident-modal"
      title="Report Incident"
      title-class="font-18"
      size="lg"
      no-close-on-backdrop
      hide-footer
      centered
    >
      <form @submit.prevent="reportIncident">
        <div>
          <div class="mb-3">
            <label>Vehicle Number</label>
            <input
              name="vehicleNumber"
              placeholder="Vehicle Plate Number"
              type="text"
              class="form-control"
              v-model="vehicleNumber"
              maxlength="10"
              style="text-transform: uppercase"
              required
            />
          </div>
          <div class="mb-3">
            <label>Driver Name</label>
            <input
              name="driverName"
              placeholder="Driver Name"
              type="text"
              class="form-control"
              v-model="driverName"
              required
            />
          </div>
          <div class="mb-3">
            <label>No. of Injured People</label>
            <input
              placeholder="No. of Injured People"
              type="number"
              class="form-control"
              v-model="injuredCount"
              required
            />
          </div>

          <div class="mb-3">
            <label>Incident Images</label>
            <file-pond
              ref="pond"
              label-idle="Attach Incident Images"
              :allow-multiple="true"
              accepted-file-types="image/jpeg, image/png"
              max-files="6"
              :files="myFiles"
              :credits="credits"
              imagePreviewMaxHeight="70"
            />
          </div>
        </div>

        <hr />
        <div class="mt-2 text-center">
          <button
            type="submit"
            class="btn btn-danger me-1 w-50"
            @click="reportIncident"
          >
            Report Incident <i class="bx bx-rocket ml-2"></i>
          </button>
        </div>
      </form>
    </b-modal>

    <!-- More details modal -->
    <b-modal
      id="more-details-modal"
      size="xl"
      title-class="font-18"
      hide-footer
    >
      <template #modal-header>
        <div><h5>Incident Details</h5></div>
        <div>
          <button class="btn btn-sm btn-outline-primary m-2" disabled>
            Status: {{ selectedIncident.status }}
          </button>
          <button
            class="btn btn-sm btn-outline-danger"
            @click="$bvModal.hide('more-details-modal')"
          >
            <i class="mdi mdi-close"></i> Close
          </button>
        </div>
      </template>

      <div class="row">
        <div class="col-xl-6">
          <div class="card">
            <div class="card-body">
              <div class="table-responsive">
                <table class="table mb-0">
                  <tbody>
                    <tr>
                      <th scope="row">Incident Id</th>
                      <td>{{ selectedIncident.id }}</td>
                    </tr>
                    <tr>
                      <th scope="row">Incident Category</th>
                      <td>{{ selectedIncident.category_name }}</td>
                    </tr>
                    <tr>
                      <th scope="row">Sub Category</th>
                      <td>{{ selectedIncident.sub_category_name }}</td>
                    </tr>
                    <tr>
                      <th scope="row">Incident Source</th>
                      <td>{{ selectedIncident.source_name }}</td>
                    </tr>
                    <tr>
                      <th scope="row">Description</th>
                      <td>{{ selectedIncident.description }}</td>
                    </tr>
                    <tr>
                      <th scope="row">Chainage Number</th>
                      <td>{{ selectedIncident.ch_no }}</td>
                    </tr>
                    <tr>
                      <th scope="row">Side</th>
                      <td>{{ selectedIncident.side_name }}</td>
                    </tr>
                    <tr>
                      <th scope="row">Nature of Accident</th>
                      <td>{{ selectedIncident.nature_of_accident }}</td>
                    </tr>
                    <tr>
                      <th scope="row">Nature of Injury</th>
                      <td>{{ selectedIncident.nature_of_injury }}</td>
                    </tr>
                    <tr>
                      <th scope="row">Name of Hospital</th>
                      <td>{{ selectedIncident.hospital_name }}</td>
                    </tr>
                    <tr>
                      <th scope="row">MBCB</th>
                      <td>{{ selectedIncident.mbcb }}</td>
                    </tr>
                    <tr>
                      <th scope="row">Hydra Time</th>
                      <td>{{ selectedIncident.hydra_time }}</td>
                    </tr>
                    <tr>
                      <th scope="row">Description</th>
                      <td>{{ selectedIncident.comment }}</td>
                    </tr>
                  </tbody>
                </table>

                <div class="mt-5">
                  <h4 class="card-title">Vehicle Details</h4>
                </div>
                <hr />
                <div class="row">
                  <div class="col-12">
                    <div class="mb-3">
                      <b-table-lite :items="items" :fields="vehicleFields">
                        <template #cell(actions)="row">
                          <b-button
                            size="sm"
                            variant="primary"
                            class="m-1"
                            @click="editVehicleDetails(row.item)"
                            >View
                          </b-button>
                        </template>
                      </b-table-lite>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <h4 class="card-title">Incident Photos</h4>
              <img
                v-for="(src, index) in incidentImages"
                :key="index"
                class="float-left image"
                @click="() => showCaptiomImg(index)"
                :src="src"
              />
            </div>
            <vue-easy-lightbox
              :visible="visibleCaption"
              :imgs="incidentImages"
              :index="index"
              @hide="handleCaptionHide"
            ></vue-easy-lightbox>
          </div>
        </div>
      </div>
    </b-modal>

    <!-- Resolve modal -->
    <b-modal
      id="mark-resolve-modal"
      title="Resolve Confirmation"
      title-class="font-18"
      hide-footer
    >
      <div class="card">
        <div class="card-body p-2">
          <form @submit.prevent="markAsResolved">
            <div class="row">
              <div class="col-12">
                <h4>Incident ID: #{{ selectedIncident.id }}</h4>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <h6>Are you sure you want to mark the incident as resolved?</h6>
                <div class="form-group text-left">
                  <label>Comment*</label>
                  <textarea
                    v-model="resolveComment"
                    class="form-control"
                    placeholder="Enter a closing comment for resolving the incident"
                    required
                  ></textarea>
                </div>
                <hr />

                <h6>Important Notes</h6>
                <ul>
                  <li>
                    <small
                      >You cannot reopen the resolved incident again.</small
                    >
                  </li>
                  <li>
                    <small
                      >Associated RPO will be notified once the incident is
                      marked as resolved.</small
                    >
                  </li>
                </ul>
              </div>
            </div>
            <hr />
            <div class="row">
              <div class="col-12 text-center">
                <button type="submit" class="btn btn-success btn-block">
                  <i class="fas fa-check"></i> Confirm & Resolve Incident
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </b-modal>

    <!-- view vehicle details -->
    <b-modal
      id="view-vehicle-details-modal"
      title="Vehicle Details"
      title-class="font-18"
      hide-footer
      no-close-on-backdrop
    >
      <template #modal-header>
        <div><h5>Accident Vehicle</h5></div>
        <div>
          <button
            class="btn btn-sm btn-outline-danger"
            @click="$bvModal.hide('view-vehicle-details-modal')"
          >
            Cancel
          </button>
        </div>
      </template>

      <div class="card">
        <div class="card-body">
          <div class="table-responsive">
            <table class="table mb-0">
              <tbody>
                <tr>
                  <th scope="row">Driver Name</th>
                  <td>{{ selectedVehicle.driver_name }}</td>
                </tr>
                <tr>
                  <th scope="row">Vehicle No.</th>
                  <td>{{ selectedVehicle.vehicle_no }}</td>
                </tr>
                <tr>
                  <th scope="row">Mobile No.</th>
                  <td>{{ selectedVehicle.mobile_no }}</td>
                </tr>
                <tr>
                  <th scope="row">Driver Address</th>
                  <td>{{ selectedVehicle.driver_address }}</td>
                </tr>
                <tr>
                  <th scope="row">Origin of Vehicle</th>
                  <td>{{ selectedVehicle.origin }}</td>
                </tr>
                <tr>
                  <th scope="row">Point of Arrival</th>
                  <td>{{ selectedVehicle.arrival }}</td>
                </tr>
                <tr>
                  <th scope="row">Destination of Vehicle</th>
                  <td>{{ selectedVehicle.destination }}</td>
                </tr>
                <tr>
                  <th scope="row">No. of Passengers</th>
                  <td>{{ selectedVehicle.passenger_count }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </b-modal>
  </Layout>
</template>

<script>
import VueEasyLightbox from "vue-easy-lightbox";
import Swal from "sweetalert2";
import incidentMixin from "@/mixins/incident";
import utilsMixin from "@/mixins/utils";
import Layout from "@/layouts/main";

export default {
  mixins: [incidentMixin, utilsMixin],

  components: {
    VueEasyLightbox,
    Layout,
  },

  data() {
    return {
      allIncidents: [],
      openIncidents: [],
      resolvedIncidents: [],
      visibleCaption: false,
      selectedIncident: {},
      vehicleNumber: null,
      driverName: null,
      injuredCount: null,
      myFiles: [],
      credits: "",
      resolveComment: "",
      index: 1,
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      sortBy: "id",
      sortDesc: true,
      filterOn: [],
      filter: null,
      fields: [
        {
          key: "id",
          label: "ID",
          sortable: true,
        },
        {
          key: "vehicle_no",
          label: "Vehicle No.",
          sortable: false,
        },
        {
          key: "category_name",
          label: "Category",
          sortable: true,
        },
        {
          key: "ch_no",
          label: "Chainage No.",
          sortable: false,
        },
        {
          key: "reported_by_name",
          label: "Reported By",
          sortable: true,
        },
        {
          key: "incident_datetime",
          label: "Date | Time",
          sortable: true,
          formatter: (value) => {
            return this.getReadableDateTime(value);
          },
        },
        {
          key: "status",
          sortable: true,
        },
        {
          key: "actions",
        },
      ],

      items: [],
      selectedVehicle: {},

      vehicleFields: [
        {
          key: "vehicle_no",
          label: "Vehicle No.",
          sortable: false,
        },
        {
          key: "driver_name",
          label: "Driver Name",
          sortable: true,
        },
        {
          key: "actions",
        },
      ],
    };
  },
  methods: {
    getUserId() {
      const userData = this.$store.getters["auth/user"];
      return userData.user.id;
    },

    showRaiseNewIncident() {
      this.$router.push("/phone/raise-incident");
    },

    showReportIncidentPage(accident) {
      this.selectedIncident = accident;
      this.$router.push({
        name: "phone-incident-report",
        params: {
          data: this.selectedIncident,
        },
      });
    },

    viewReportIncidentPage(accident) {
      this.selectedIncident = accident;
      this.$router.push({
        name: "phone-incident-details",
        params: {
          data: this.selectedIncident,
        },
      });
    },

    getStatusClass(status) {
      switch (status) {
        case "Open":
          return "bg-danger";

        case "In Progress":
          return "bg-warning";

        case "Resolved":
          return "bg-success";

        case "Closed":
          return "bg-success";

        default:
          return "bg-info";
      }
    },

    async getIncidentDetails() {
      this.allIncidents = [];
      const userId = this.getUserId();
      const incidents = await this.GetRpoIncidens(userId);
      for (let incident of incidents) {
        this.allIncidents.push({
          ...incident,
        });
      }

      this.allIncidents.reverse();

      this.openIncidents = this.allIncidents.filter(
        (data) => data.status === "Open"
      );

      this.resolvedIncidents = this.allIncidents.filter(
        (data) => data.status === "Resolved"
      );
      this.totalRows = this.allIncidents.length;
    },

    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    getReadableDateTime(dateTime) {
      if (dateTime) {
        const date = String(dateTime).split("T");
        return `${date[0].toUpperCase()}, ${date[1].toUpperCase()}`;
      }
    },

    async showIncidentDetails(incident) {
      this.selectedIncident = incident;
      this.$bvModal.show("more-details-modal");
    },

    showReportModal(incident) {
      this.selectedIncident = incident;
      this.$bvModal.show("report-incident-modal");
      this.vehicleNumber = this.selectedIncident.vehicle_no;
      this.driverName = this.selectedIncident.driver_name;
      this.injuredCount = this.selectedIncident.injured_count;
    },

    showCaptiomImg(index) {
      this.index = index;
      this.visibleCaption = true;
    },

    handleCaptionHide() {
      this.visibleCaption = false;
    },

    showResolveConfirmation() {
      this.$bvModal.show("mark-resolve-modal");
    },

    async markAsResolved() {
      try {
        this.$store.dispatch("layout/changeLoaderValue", true);

        const body = {
          id: this.selectedIncident.id,
          comment: this.resolveComment,
        };

        await this.ResolveIncident(body);
        await this.getIncidentDetails();

        this.$store.dispatch("layout/changeLoaderValue", false);
        Swal.fire(
          "Incident Resolved",
          "Incident has been resolved and notifications have been sent out to respective teams",
          "success"
        ).then(() => {
          this.$bvModal.hide("mark-resolve-modal");
          this.$bvModal.hide("more-details-modal");
        });
      } catch (e) {
        Swal.fire(
          "Operation Failed",
          "Failed to resolve the incident due to some technical issue.",
          "error"
        ).then(() => {
          this.$bvModal.hide("more-details-modal");
        });
      }
    },

    reportGenerated(incidentId) {
      Swal.fire(
        "Report Generated",
        "Report has been generated to this incident",
        "success"
      ).then(() => {
        this.$bvModal.hide("report-incident-modal");
      });
    },

    async reportIncident() {
      await this.reportGenerated();
      const body = {
        id: this.selectedIncident.id,
        vehicle_no: this.vehicleNumber,
        driver_name: this.driverName,
        injured_count: this.injuredCount,
      };
      await this.ReportIncident(body);
    },

    editVehicleDetails(vehicle) {
      this.selectedVehicle = vehicle;
      this.$bvModal.show("view-vehicle-details-modal");
    },
  },

  computed: {
    isMobile() {
      return this.IsMobileDevice();
    },
    rows() {
      return this.allIncidents.length;
    },
    incidentImages() {
      return this.selectedIncident.images
        ? this.selectedIncident.images.map((e) => e.media_url)
        : [];
    },

    incidents() {
      return this.$store.getters["incident/incidents"];
    },
  },

  async mounted() {
    this.$store.dispatch("layout/changeLoaderValue", true);
    await this.getIncidentDetails();
    this.$store.dispatch("layout/changeLoaderValue", false);
  },
};
</script>
<style scoped>
.image {
  height: 100px;
  cursor: pointer;
  margin: 5px;
  display: inline-block;
}

@media only screen and (max-width: 600px) {
  .webViewTable {
    display: none;
  }

  .mobileView {
    margin: 0 auto; /* Added */
    float: none; /* Added */
    margin-bottom: 10px; /* Added */
  }
}

@media only screen and (min-width: 600px) {
  .mobileView {
    display: none;
  }
}

::-webkit-input-placeholder {
  text-align: center;
}
</style>
